import { motion } from "framer-motion";

export const LegalLayout = ({ eyebrow = "Legal", title, updated, intro, testId = "legal-page", children }) => {
  return (
    <section data-testid={testId} className="relative px-6 pb-24 pt-32 md:px-12 md:pt-40">
      <div className="mx-auto max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-aura-pink">
            {eyebrow}
          </p>
          <h1 className="mt-4 font-heading text-4xl font-semibold tracking-tighter text-aura-ink sm:text-5xl">
            {title}
          </h1>
          {updated && (
            <p className="mt-4 text-sm text-aura-muted">Last updated: {updated}</p>
          )}
          {intro && (
            <p className="mt-6 border-l-2 border-aura-pink pl-4 text-[15px] leading-7 text-aura-text2">
              {intro}
            </p>
          )}
        </motion.div>

        <div className="legal-body mt-4">{children}</div>
      </div>
    </section>
  );
};
